import { render, staticRenderFns } from "./checked-tag.vue?vue&type=template&id=5bb9bd65&scoped=true"
import script from "./checked-tag.vue?vue&type=script&lang=js"
export * from "./checked-tag.vue?vue&type=script&lang=js"
import style0 from "./checked-tag.vue?vue&type=style&index=0&id=5bb9bd65&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bb9bd65",
  null
  
)

export default component.exports